import BadgeT from '@components/tailwind-components/Badge/BadgeT';
import type React from 'react';

type KeywordBadgeProps = {
  keyword: string;
  onRemove?: () => void;
  className?: string;
};

const KeywordBadge: React.FC<KeywordBadgeProps> = ({
  keyword,
  onRemove,
  className = '',
}) => (
  <BadgeT
    text={`#${keyword}`}
    bgColorHex='#7C3AED'
    className={`font-thin text-pico inline-flex leading-none py-1 !rounded-sm ${className}`}
    shouldOverrideTextSize={true}
    onRemove={onRemove}
  />
);

export default KeywordBadge;
